// =============================================================
// 全局咨询弹窗开关（Vue 2 · Options API）
// 使用模块级 singleton + Vue.observable 实现跨组件共享状态
// =============================================================
import Vue from 'vue'

const store = Vue.observable({ isOpen: false })

export const consultStore = store

export function useConsult() {
  return {
    open() {
      store.isOpen = true
    },
    close() {
      store.isOpen = false
    },
    toggle() {
      store.isOpen = !store.isOpen
    },
  }
}



// WEBPACK FOOTER //
// ./src/site/composables/useConsult.js